import type { FC, ReactNode } from 'react'

import { MapPin } from 'lucide-react'
import { SectionHeading } from '@/components/generals/section-heading'
import { areasServed } from '@/constants/site'

export const AreasSection: FC = (): ReactNode => {
    return (
        <section
            id='areas'
            aria-labelledby='areas-title'
            className='plum-glow relative isolate overflow-hidden py-20 text-ivory sm:py-24'
        >
            <div aria-hidden='true' className='pointer-events-none absolute -left-24 bottom-0 -z-10 size-80 rounded-full bg-gold/10 blur-3xl' />

            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='areas-title'
                    tone='dark'
                    eyebrow='Areas we serve'
                    title='Your nearby beauty parlour in North Delhi'
                    description='Women visit us from all around New Gupta Colony and North Delhi. If you live or work nearby, we are just a short ride away.'
                />

                <ul className='mx-auto mt-12 flex max-w-5xl flex-wrap justify-center gap-2.5'>
                    {areasServed.map(area => (
                        <li
                            key={area}
                            className='inline-flex items-center gap-1.5 rounded-full border border-gold/25 bg-white/5 px-4 py-2 text-sm text-ivory/85'
                        >
                            <MapPin className='size-3.5 text-gold' aria-hidden='true' />
                            {area}
                        </li>
                    ))}
                </ul>

                <p className='mx-auto mt-12 max-w-3xl text-center text-sm leading-relaxed text-ivory/65'>
                    Looking for the best beauty parlour nearby, a nail salon or facial parlour near you, or a bridal beauty makeup artist in Delhi? Anushka Beauty Parlour brings HD and airbrush bridal looks, party makeovers and draping, designer nail arts and extensions, organic skin treatments, facial cleanup, hair keratin and bridal hair designs together under one roof in New Gupta Colony, close to Model Town, Vijay Nagar, GTB Nagar, Hudson Lane, Kamla Nagar, Roop Nagar and Shakti Nagar.
                </p>
            </div>
        </section>
    )
}
